import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ExclusionModal from 'component/Modal/ExclusionModal'
import Glyph from 'component/utils/Glyph'
import { isEmpty } from 'utils/validations'
import ArrowIcon from "../../../images/arrow-down-fill.svg"
import './styles.css'


const Table = ({ records, translate, handleDelete, editEntry, storeList, handleOrderDirection }) => {
  const putBranchQuantity = (stores) => (stores.length - 2 ? translate('scheduleBlock.branchs').toLowerCase() : translate('field.store').toLowerCase())

  const parseStores = (stores = [], allStores = []) => {
    const [firstStore] = stores

    return (
      <span>
        {`${firstStore.idBranch} - ${(allStores.find((store) => store.id === (firstStore || {}).idBranch) || {}).name}`}
        <strong>{stores.length - 1 ? ` + ${stores.length - 1} ${putBranchQuantity(stores)}` : ''}</strong>
      </span>
    )
  }

  const wareHouseComplement = (id) => {
    switch (id) {
      case 'C050':
        return translate('field.store')
      case 'C010':
        return 'Supply'

      default:
        return ''
    }
  }

  const [isArrowRotated, setIsArrowRotated] = useState(false);

  const onOrderChange = ()=>{
    setIsArrowRotated(!isArrowRotated);
    handleOrderDirection();
  }

  return (
    <div className='new-style new-outer-table outer-table'>
      <table cellPadding={0} cellSpacing={0} className='new-table margin-top'>
        <thead style={{ whiteSpace: 'nowrap' }}>
          <tr>
            <th className={`cursor-pointer ${isArrowRotated ? 'arrow-transition' : ''}`} onClick={onOrderChange}>{translate('scheduleBlock.lastEdit')}
              <img src={ArrowIcon} alt="arrow icon" className={`margin-left-extra-small ${isArrowRotated ? 'arrow-up' : ''}`} />
            </th>
            <th>{translate('scheduleBlock.period')}</th>
            <th>Título</th>
            <th>{translate('scheduleBlock.reason')}</th>
            <th>{translate('scheduleBlock.branchs')}</th>
            <th>{translate('schedule.block.type')}</th>
            <th>{translate('scheduleBlock.repetition')}</th>
            <th className='text-align-center'>
              {translate('scheduleBlock.edit')}
            </th>
            <th className='text-align-center'>
              {translate('scheduleBlock.remove')}
            </th>
          </tr>
        </thead>
        <tbody>
          <>
            {(records || []).map((entry, idx) => {
              const {
                lastEdit,
                date,
                dsScheduleBlock,
                dsReasonScheduleBlock,
                inRepeatAnnually,
                listScheduleBlockBranchsModel,
                idScheduleBlock,
                wareHouseId,
              } = entry

              return (
                <>
                  <tr key={`${idScheduleBlock}-${idx}`}>
                    <td className='text-align-center' style={{ whiteSpace: 'nowrap' }}>{lastEdit || '-'}</td>
                    <td>{date}</td>
                    <td>{dsScheduleBlock} </td>
                    <td>{!isEmpty(dsReasonScheduleBlock) ? dsReasonScheduleBlock :  dsScheduleBlock}</td>
                    <td>
                      {parseStores(listScheduleBlockBranchsModel, storeList)}
                    </td>
                    <td>{`${wareHouseId === "ghost" ? "Fantasma" : wareHouseId || ''} ${wareHouseId !== "ghost" ? ' - ' : ''} ${wareHouseComplement(wareHouseId)}`}</td>
                    <td>
                      {translate(
                        `scheduleBlock.inRepeatAnnually.${
                          inRepeatAnnually ? 'annually' : 'once'
                        }`
                      )}
                    </td>
                    <td className='text-align-center'>
                      <Glyph
                        type='pencil'
                        color='primary'
                        customClass='cursor-pointer font-20'
                        onClick={() => editEntry({...entry, wareHouseId})}
                      />
                    </td>
                    <td className='text-align-center'>
                      <ExclusionModal
                        size='sm'
                        className="schedule-block-edit-modal"
                        t={translate}
                        title={translate('exclude_button')}
                        onConfirm={() =>
                          handleDelete(
                            idScheduleBlock,
                            listScheduleBlockBranchsModel
                          )
                        }
                        message={
                          <>
                            {translate('scheduleBlock.confirm-message-remove')}
                            <br />
                            <b> {dsScheduleBlock} </b>
                          </>
                        }
                        cancelButtonMsg='close_button_label'
                        confirmButtonMsg='approvers.remove.confirm'
                        renderButton={({ onClick }) => (
                          <a
                            id={`view-mission-${idx}`}
                            role='button'
                            onClick={onClick}
                          >
                            <i className='color-danger glyph glyph-trash-can icon-size' />
                          </a>
                        )}
                      />
                    </td>
                  </tr>
                </>
              )
            })}
          </>
        </tbody>
      </table>
    </div>
  )
}

Table.propTypes = {
  records: PropTypes.array.isRequired,
  translate: PropTypes.func,
  handleDelete: PropTypes.func,
  editEntry: PropTypes.func,
  storeList: PropTypes.func,
  handleOrderDirection: PropTypes.func,
}

export default Table
